import { render, staticRenderFns } from "./SelectLanguage.vue?vue&type=template&id=49e40909"
import script from "./SelectLanguage.vue?vue&type=script&lang=js"
export * from "./SelectLanguage.vue?vue&type=script&lang=js"
import style0 from "./SelectLanguage.vue?vue&type=style&index=0&id=49e40909&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports